// src/pages/Vote.jsx
import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import Footer from '../components/Footer';

function Vote() {
  return (
    <Box
      sx={{
        minHeight: '100vh',         // 화면을 꽉 채우고 싶다면 사용
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        py: 5,
        mt: {sm:10,}
      }}
    >
      {/* 상단 제목 */}
      <Typography variant="h2" sx={{ fontWeight: 'bold', mb: 3 }}>
        추천하기
      </Typography>

      {/* 설명 문구 (원하시면 생략 가능) */}
      <Typography variant="body1" sx={{ mb: { xs: 1, sm: 3, md: 5 }, textAlign: 'center', fontSize: { xs: '1rem', sm: '1.2rem', md: '1.5rem' }, }}>
        아래 사이트에서 전적이를 추천 해주세요!
        <br/>
        각각의 사이트에서 추천할 때마다 50만 코인을 지급해 드립니다.
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {/* top.gg로 이동 */}
        <Grid item>
          <Box
            component="img"
            src="/topggbanner.webp"           // 퍼블릭 폴더 내 topgg.png (또는 webp 등)
            alt="top.gg로 이동"
            sx={{
              width: { xs: 350, sm: 400, md: 600 },             // 이미지 크기
              height: 'auto',
              cursor: 'pointer',
              borderRadius: 2,
              transition: '0.3s',
              '&:hover': {
                transform: 'scale(1.05)',  // 살짝 커지는 애니메이션
              },
            }}
            onClick={() => {
              window.open('https://top.gg/bot/996765559603613747/vote', '_blank');
            }}
          />
        </Grid>

        {/* 한국 디스코드 리스트(koreanbots.dev)로 이동 */}
        <Grid item>
          <Box
            component="img"
            src="/koreanbotsbanner.webp"      // 퍼블릭 폴더 내 koreanbots.png (또는 webp 등)
            alt="koreanbots로 이동"
            sx={{
              width: { xs: 350, sm: 400, md: 600 },
              height: 'auto',
              cursor: 'pointer',
              borderRadius: 2,
              transition: '0.3s',
              '&:hover': {
                transform: 'scale(1.05)',
              },
            }}
            onClick={() => {
              window.open('https://koreanbots.dev/bots/996765559603613747/vote', '_blank');
            }}
          />
        </Grid>
      </Grid>
      <Footer />
    </Box>
  );
}

export default Vote;
